import React from 'react';
import { Redirect } from "react-router-dom";

import Header from "../../components/Header";
import FavoriteButton from "../../components/FavoriteButton";
import Form from "../../components/brews/Form";
import Images from "../../components/brews/Images";

import BannerImage from '../../images/brew-item-banner.jpg';

import defaultBrewState from "../../static/defaultBrewState.json";

import GlobalData from '../../context/globaldata';

class Brew extends React.PureComponent {
  static contextType = GlobalData;

  constructor(props) {
    super(props);
    this.state = {
      ...defaultBrewState,
      toBrews: false,
      overflowVisible: false,
      saving: false,
      notesVisible: false
    };

    this.saveBrew = this.debounce(this.saveBrew.bind(this), 1000);
    this.addImage = this.addImage.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
  };

  debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      const later = function() {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  handleChange = (event, actionMeta) => {
    const target = event ? event.target : false;
    const key = target ? target.name : actionMeta.name || '';
    const value = target ? target.type === 'checkbox' ? target.checked : target.value : event;

    this.saveBrewState(key, value);
  };

  saveBrew = () => {
    this.setState({
      saving: true
    }, () => {
      if(this.state.brew.name) {
        this.currentBrew.set(this.state.brew).then(() => {
          this.setState({
            saving: false
          });
          this.context.addNotification('Brew saved', 'Your changes have been successfully saved', 'success', 'right', 'bottom-right');
        });
      } else {
        this.setState({
          saving: false
        });
        this.context.addNotification('Error', "You didn't fill in all required fields", 'danger', 'right', 'bottom-right');
      }
    });
  };

  getBrew = (brewId) => {
    this.currentBrew = this.context.db.collection("brews").doc(brewId);
    this.currentSnapshot = this.currentBrew.onSnapshot((doc) => {
      if(!doc.exists) {
        this.setState({
          toBrews: true
        })
      } else {
        this.setState({
          brew: doc.data(),
          brewId: brewId,
          hasLoaded: true,
          readOnlyMode: doc.data().user === this.context.currentUser.uid ? false : true
        });
      }
    });
  };

  trashBrew = () => {
    this.setState({
      brew: {
        ...this.state.brew,
        trashed: true
      }
    }, () => {
      this.currentBrew.set(this.state.brew).then(() => {
        this.setState({
          toBrews: true
        });
      });
    });
  };

  deleteBrew = () => {
    if(window.confirm("Are you sure you want to delete this brew? This action can't be undone!")) {
      this.setState({
        toBrews: true
      });

      this.currentBrew.delete().then(() => {
        this.context.addNotification('Brew deleted', 'The brew has been successfully deleted', 'default', 'right', 'bottom-right');
        this.context.updateBrewAmount();
      }).catch((error) => {
        this.context.addNotification('Error', 'There was an error while trying to remove this brew, try again later.', 'danger', 'right', 'bottom-right');
      });
    }
  };

  saveBrewState = (key, value) => {
    this.setState({
      brew: {
        ...this.state.brew,
        [key]: value
      }
    }, () => {
      this.saveBrew();
    })
  };

  deleteImage = (ref) => {

    var newImagesState = this.state.brew.images.filter(obj => {
      return obj.refPath !== ref;
    });

    this.setState({
      brew: {
        ...this.state.brew,
        images: newImagesState
      }
    }, () => {
      var imageRef = this.context.storageBucketRef.child(ref);

      imageRef.delete().then(() => {
        this.saveBrew();
      }).catch((error) => {
        this.context.addNotification('Error', error, 'danger', 'right', 'bottom-right');
      });
    })
  };

  addImage(data) {
    var brewAttachmentsRef = this.context.storageBucketRef.child('brew-attachments');
    var attachmentRef = brewAttachmentsRef.child(data.attachment.name);
    data.refPath = brewAttachmentsRef.child(data.attachment.name).fullPath;

    this.setState(prevState => {
      return ({
        brew: {
          ...prevState.brew,
          images: [
            ...prevState.brew.images,
            data
          ]
        }
      })
    }, () => {
      this.uploadImage(data, attachmentRef);
    });
  };

  uploadImage = (attachment, attachmentRef) => {
    var file = attachment.attachment;
    var metaData = {
      contentType: file.type
    }

    const uploadTask = attachmentRef.put(file, metaData);

    uploadTask.on('state_changed', snapshot => {
      // Upload in progress
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
      this.setState({
          brew: {
            ...this.state.brew,
            images: this.state.brew.images.map(el => (el.refPath === attachment.refPath ? {
              ...el,
              progress: progress,
              uploading: true
            } : el ))
          }
        }
      );
    }, (error) => {
      // Upload error
      console.log('Error: ' + error);
    }, () => {
      // Upload completed
      uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
        this.setState(prevState => {
          const brew = {...prevState.brew};
          brew.images.some(image => {
            if (image.refPath === attachment.refPath) {
              delete image.progress;
              image.uploading = false;
              image.url = downloadURL;
              image.refPath = uploadTask.snapshot.ref.fullPath;
            }
          });
          return { brew };
        }, () => {
          // this.saveBrew();
        });

        // this.setState({
        //   brew: {
        //     ...this.state.brew,
        //     images: this.state.brew.images.map(el => (el.refPath === attachment.refPath ? {
        //       ...el,
        //       progress: 100,
        //       uploading: false,
        //       url: downloadURL,
        //       refPath: uploadTask.snapshot.ref.fullPath
        //     } : el ))
        //   }
        // }, () => {
        //   // this.saveBrew();
        // });
      });
    });
  };

  updateImage = (imageRef, updateKey, updateValue) => {
    this.setState({
      brew: {
        ...this.state.brew,
        images: this.state.brew.images.map(el => (el.refPath === imageRef ? {
          ...el,
          [updateKey]: updateValue
        } : el ))
      }
    });
  };

  updateRating = (rating) => {
    this.saveBrewState('rating', rating);
  };

  updateNotes = (notes) => {
    if(!this.state.readOnlyMode) {
      this.setState({
        brew: {
          ...this.state.brew,
          notes: notes
        }
      }, () => {
        this.saveBrew();
      });
    }
  };

  submitForm = (event) => {
    event.preventDefault();
    this.saveBrew();
  };

  toggleOverflowMenu = () => {
    this.setState({
      overflowVisible: !this.state.overflowVisible
    });
  };

  componentDidMount() {
    this.getBrew(this.props.params.brewId);
  };

  componentWillUnmount() {
    if(this.hasOwnProperty('currentSnapshot')) {
      this.currentSnapshot();
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.params.brewId !== prevProps.params.brewId && !this.state.toBrews) {
      this.getBrew(this.props.params.brewId);
    }
  };

  render() {
    this.readOnlyMode = this.state.readOnlyMode ? true : false;
    this.currentUser = this.context.currentUser || null;

    if(!this.currentUser) {
      return null
    }

    if(!this.state.brew || this.state.toBrews === true) {
      return <Redirect to={ '/brews/' } />
    }

    return (
      <section className={`brew brew--single ${ this.state.hasLoaded ? 'is-visible' : '' } ${ this.state.brew.banner_image ? 'has-banner' : ''} `}>
        <div className="brew__wrapper">
          <Header className="header--brew" title={ this.state.brew.name }>
            { this.currentUser && this.currentUser.uid === this.state.brew.user &&
              <div className="header__actions">
                { this.state.brew.trashed ? (
                  <button className="button button--primary" type="button" onClick={ () => this.saveBrewState('trashed', false) }>Restore brew</button>
                ) : (
                  <React.Fragment>
                    <button className={`button button--primary ${ this.state.saving ? 'is-loading' : '' }`} onClick={ this.saveBrew }>
                      <span>Save changes</span>
                    </button>
                    <FavoriteButton property={ this.state.brew.favorite } callback={ () => this.saveBrewState('favorite', !this.state.brew.favorite) } />
                  </React.Fragment>
                )}
                <div className={`overflow-menu ${ this.state.overflowVisible ? 'is-visible' : '' }`}>
                  <div className="overflow-menu__overlay" onClick={ this.toggleOverflowMenu }></div>
                  <button className="button button--tertiary button--rounded" type="button" onClick={ this.toggleOverflowMenu }>
                    <i className="material-icons">more_vert</i>
                  </button>
                  <div className="overflow-menu__box">
                    <button className="overflow-menu__button" type="button" onClick={ this.saveBrew }>
                      <i className="material-icons">save</i>
                      <span>Save changes</span>
                      <span className="overflow-menu__shortcut">⌃ + ⇧ + S</span>
                    </button>
                    { this.context.userSettings.premium_user &&
                      <button className="overflow-menu__button" type="button" onClick={ this.trashBrew }>
                        <i className="material-icons">link</i>
                        <span>Add linked brew</span>
                        <span className="overflow-menu__shortcut"></span>
                      </button>
                    }
                    <button className="overflow-menu__button" type="button" onClick={ this.trashBrew }>
                      <i className="material-icons">control_point_duplicate</i>
                      <span>Duplicate</span>
                      <span className="overflow-menu__shortcut"></span>
                    </button>
                    <div className="overflow-menu__line"></div>
                    <button className="overflow-menu__button" type="button" onClick={ this.trashBrew }>
                      <i className="material-icons">delete</i>
                      <span>Trash</span>
                      <span className="overflow-menu__shortcut">⌃ + ⇧ + Q</span>
                    </button>
                    <button className="overflow-menu__button" type="button" onClick={ this.deleteBrew }>
                      <i className="material-icons">delete_forever</i>
                      <span>Permanently delete</span>
                    </button>
                  </div>
                </div>
              </div>
            }
          </Header>

          { this.state.brew.banner_image &&
            <div className="brew-banner">
              <div className="brew-banner__media" style={{ backgroundImage: `url(${ BannerImage })` }}></div>
            </div>
          }

          <Form
            brew={ this.state.brew }
            handleChange={ this.handleChange }
            updateNotes={ this.updateNotes }
            saveBrewState={ this.saveBrewState }
            updateRating={ this.updateRating }
            readOnlyMode={ this.readOnlyMode }
            submitForm={ this.submitForm }
          />

          { this.context.userSettings.premium_user &&
            <Images
              addImage={ this.addImage }
              brewImages={ this.state.brew.images }
              updateImage={ this.updateImage }
              deleteImage={ this.deleteImage }
            />
          }

        </div>
      </section>
    );
  }
}

export default Brew;
